module.exports = __webpack_public_path__ + "media/images/a-89ef073d875094d08f923496bd2f35a8.png";